import { OpenDrawerParams } from 'types/drawers';

export enum DrawersActionTypes {
  OPEN_DRAWER = '@@drawers/OPEN_DRAWER',
  CLOSE_DRAWER = '@@drawers/CLOSE_DRAWER',
  UPDATE_DRAWER_WIDTH = '@@drawers/UPDATE_DRAWER_WIDTH',
}

export interface DrawersState {
  activeDrawers: OpenDrawerParams[];
  width: number;
}
